import { InputWithValidation } from 'acscp/components/common/validation/inputWithValidation';
import classNames from 'classnames';
import formStyle from 'acscp/components/common/form.module.scss';
import React from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';
import { ValidationErrors } from 'acscp/api/models/errorDetails';
import { Country } from 'acscp/api/models/country';

const messages = defineMessages({
    statePlaceholder: {
        id: 'web.components.auth.createAccountForm.stateOfResidencePlaceholder',
        defaultMessage: 'STATE'
    },
    provincePlaceholder: {
        id: 'web.components.auth.createAccountForm.provincePlaceholder',
        defaultMessage: 'PROVINCE'
    }
});

interface StateOfResidenceInputOwnProps {
    inputName: string;
    validationErrors: ValidationErrors | undefined;
    optionsAreLoading: boolean;
    country?: Country;
    valueId: string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

type StateOfResidenceInputProps = InjectedIntlProps & StateOfResidenceInputOwnProps;

export const StateOfResidenceInputPresentational: React.FC<StateOfResidenceInputProps> = props => (
    <InputWithValidation
        name={props.inputName}
        validationErrors={props.validationErrors}
    >
        <select
            name={props.inputName}
            id={props.inputName}
            value={props.valueId}
            onChange={props.onChange}
            disabled={props.optionsAreLoading}
            className={classNames({[formStyle.SelectPlaceholder]: !props.valueId})}
        >
            <option value="" className={formStyle.Placeholder}>
                {props.country && props.country.stateType === 'STATE'
                    ? props.intl.formatMessage(messages.statePlaceholder)
                    : props.intl.formatMessage(messages.provincePlaceholder)}
            </option>
            {props.country && props.country.states.map(s => (
                <option value={s.id} key={s.id}>{s.name}</option>
            ))}
        </select>
    </InputWithValidation>
);

export const StateOfResidenceInput = injectIntl(StateOfResidenceInputPresentational);
